import React, { useEffect, useState } from "react";
import {
  OtherTreatmentsForm,
  OtherTreatmentsProps,
} from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputNew";

const OtherTreatments: React.FC<OtherTreatmentsProps> = ({ onChange }) => {
  const [form, setForm] = useState<OtherTreatmentsForm>({
    requirement: "",
  });

  const handleChange = (field: keyof OtherTreatmentsForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  return (
    <div className="w-full text-[var(--cu-text)]">
      <div className="mb-3 border-b border-[var(--cu-border)] pb-2">
        <h2 className="text-sm font-medium text-[var(--cu-accent)]">
          Other Treatments
        </h2>
      </div>

      <div className="w-full space-y-3">
        <TextInput
          label="Please specify requirement"
          name="requirement"
          value={form.requirement}
          onChange={(e) => handleChange("requirement", e.target.value)}
        />
      </div>
    </div>
  );
};

export default OtherTreatments;
